import type { TrackMetricProps } from '@ecomm/tracking'
import type { CreateOrderV1Response as CreateOrderResponse } from '@simplisafe/ss-ecomm-data/simplisafe'

export const getCookieDomain = () => {
  return process.env['LOCALE'] === 'en-GB'
    ? '.simplisafe.co.uk'
    : '.simplisafe.com'
}

export const getOrderId = (response: CreateOrderResponse) =>
  response['orderNumber']

export const forwardToPaymentErrorUrl = (
  error: Error,
  trackMetricEvent: TrackMetricProps
) => {
  trackMetricEvent('forwarded-to-payment-error', {
    paymentError: error.message
  })
  navigateLocal(
    `${window.location.origin}${
      window.location.pathname
    }?error=${encodeURIComponent(error.message)}`
  )
}

export const navigateLocal = (destinationUrl: string, delayMs = 0) => {
  delayMs
    ? setTimeout(() => {
        window.location.href = destinationUrl
      }, delayMs)
    : (window.location.href = destinationUrl)
}
